module.exports = __webpack_public_path__ + "img/privcy and policy.fc6d333a.png";